import { fork, put, select, takeLatest } from "redux-saga/effects";

import ApiClient from "../../../api/ApiClient";
import { getIsWeb } from "../../../lib/platformHelper";
import { actions, constants } from "./index";
import { getProfileMenuFetched } from "./selector";

function* onFetchMenu() {
  try {
    // Web keeps the untyped endpoint until the new layout ships there.
    // Native filters with menu_type=menu / menu_type=profile.
    const { data } = yield ApiClient.get({
      urlPath: getIsWeb() ? "app.menu" : "app.menuTyped",
      skipAccessCheck: true
    });

    yield put(actions.fetchMenuSuccess(data));

    if (getIsWeb()) {
      let event = new Event("resize");
      window.dispatchEvent(event);
    }
  } catch (error) {
    yield put(actions.fetchMenuError());

    console.error(error);
  }
}

function* onFetchProfileMenu() {
  if (getIsWeb()) {
    return;
  }

  const profileFetched = yield select(getProfileMenuFetched);

  if (profileFetched) {
    return;
  }

  try {
    const { data } = yield ApiClient.get({
      urlPath: "app.menuProfile",
      skipAccessCheck: true
    });

    yield put(actions.fetchProfileMenuSuccess(data));
  } catch (error) {
    yield put(actions.fetchProfileMenuError());

    console.error(error);
  }
}

function* watchFetchMenu() {
  yield takeLatest(constants.FETCH_MENU, onFetchMenu);
}

function* watchFetchProfileMenu() {
  yield takeLatest(constants.FETCH_PROFILE_MENU, onFetchProfileMenu);
}

export default [fork(watchFetchMenu), fork(watchFetchProfileMenu)];
